const devicesWithDynamicIsland = [{
  brand: 'Apple',
  model: 'iPhone 14 Pro'
}, {
  brand: 'Apple',
  model: 'iPhone 14 Pro Max'
}];
export default devicesWithDynamicIsland;
//# sourceMappingURL=devicesWithDynamicIsland.js.map